export const formatTime = (timeString) => {
  const options = { hour: 'numeric', minute: 'numeric', hour12: true };
  return new Date(timeString).toLocaleTimeString(undefined, options);
};

export const formatDate = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  const hours = String(date.getHours()).padStart(2, '0');
  const minutes = String(date.getMinutes()).padStart(2, '0');
  const seconds = String(date.getSeconds()).padStart(2, '0');
  return `${year}-${month}-${day}T${hours}:${minutes}:${seconds}Z`;
};

export const generateEndpoint = () => {
  const today = new Date();
  const dayOfWeek = today.getDay();
  const oneWeekAgo = new Date(today.getTime() - ((dayOfWeek + 6) % 7) * 24 * 60 * 60 * 1000);
  const oneWeekFromNow = new Date(oneWeekAgo.getTime() + 7 * 24 * 60 * 60 * 1000);
  const formattedFrom = formatDate(oneWeekAgo);
  const formattedTo = formatDate(oneWeekFromNow);
  return `/desk/event_occurrences?from=${formattedFrom}&to=${formattedTo}`;
};

export const generateInRange = (start, end) => {
  return `/desk/event_occurrences?from=${start}&to=${end}`;
};

export const formatLocaleDate = (dateString) => {
  const options = {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
  };
  return new Date(dateString).toLocaleDateString('en-US', options);
};

export const isSunday = (dateString) => {
  return new Date(dateString).getDay() === 0;
};
